import withVerticalFactory from '@shared/common-vertical';

import reducers from './lib/reducers';
import verticalMiddleware from './lib/middleware';

export default withVerticalFactory(verticalMiddleware, reducers);
